





define(['endpoints', 'rest/request/requestFactory', 'apiKeyNames'],
    function(endpoints, requestFactory, ApiKeyNames) {
        'use strict';

        return function() {
            return {
                flowSegmentData: requestFactory.single(endpoints.flowSegmentData, ApiKeyNames.traffic)
            };
        };
    }
);



// WEBPACK FOOTER //
// ./rest/flowSegmentData.js